import { OWNER_FILTER_SCOPES_VALUES } from '../../constants';

/**
 * Filter owner scopes
 * @param {string[]} owners
 * @returns {string[]}
 */
export const filterOwnersScope = (owners) => {
  let isOwnerScopeIncluded = false;
  return owners.filter((owner) => {
    if (!isOwnerScopeIncluded) {
      isOwnerScopeIncluded = OWNER_FILTER_SCOPES_VALUES.includes(owner);
      return true;
    }
    return !OWNER_FILTER_SCOPES_VALUES.includes(owner);
  });
};

/**
 * Parses payload fetched from user service
 * to the proper format that resides within
 * filters -> owners -> items
 * @param {Object[]} users
 * @returns {Object[]}
 */
export const parseToUsersMap = (users) => (
  users.map((user) => ({
    id: user.id,
    label: user.username,
    name: user.username,
    type: 'user',
  }))
);
